import { Model } from "@/models";

export default class AgentCompanyAssociation extends Model {
  static type = "clientsAgentCompanyAssociations";

  agencyAgentEndDate?: string;
  agencyAgentId?: string;
  agencyAgentStartDate?: string;
  agencyEndDate?: string;
  agencyId?: string;
  agencyName?: string;
  agencyStartDate?: string;
  agentCompanyId?: string;
  agentCompanyName?: string;
}
